"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var classnames_1 = __importDefault(require("classnames"));
var inversify_react_1 = require("inversify-react");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var QuoteBlockStore_1 = __importDefault(require("QuoteV2/Stores/QuoteBlockStore"));
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var DiscountPill_1 = __importDefault(require("./DiscountPill"));
var QuoteComponents_1 = require("./QuoteComponents");
var c = (0, BemBuilder_1.default)("quote-total");
var QuoteTotalSeparator = function () { return react_1.default.createElement("hr", { className: (0, classnames_1.default)(c("separator")) }); };
var QuoteTotal = (function (_super) {
    __extends(QuoteTotal, _super);
    function QuoteTotal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.preDiscountForBlockTotal = function (total) {
            return total.postTax + total.quoteDiscount;
        };
        return _this;
    }
    Object.defineProperty(QuoteTotal.prototype, "hasRecurringTotals", {
        get: function () {
            var recurringTotals = this.quote.total.recurringTotals;
            return !(0, lodash_1.isEmpty)(recurringTotals);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteTotal.prototype, "showTaxTotals", {
        get: function () {
            return this.quote.showTaxTotals && !(0, lodash_1.isEmpty)(this.quote.total.totalTaxes);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuoteTotal.prototype, "sortedRecurringTotals", {
        get: function () {
            var recurringTotals = this.quote.total.recurringTotals;
            var mapped = (0, lodash_1.map)(recurringTotals, function (total, key) { return (__assign(__assign({}, total), { frequency: key })); });
            return (0, lodash_1.sortBy)(mapped, function (x) { return (0, lodash_1.indexOf)(Recurrence_1.recurringFrequencyDisplayOrder, x.frequency); });
        },
        enumerable: false,
        configurable: true
    });
    QuoteTotal.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.quote.total, oneOffTotals = _b.oneOffTotals, recurringTotals = _b.recurringTotals, finalQuoteTotal = __rest(_b, ["oneOffTotals", "recurringTotals"]);
        var cumulativeDiscountAsNegative = finalQuoteTotal.cumulativeDiscount * -1;
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c(), "project-block__widget-element") },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(c("card"), "user-font") },
                react_1.default.createElement(DiscountPill_1.default, { discount: this.quote.discount, className: c("discount") }),
                react_1.default.createElement("div", { className: (0, classnames_1.default)(c("section"), c("section", "main")) },
                    this.quote.showTotalDiscounts && (react_1.default.createElement("div", { className: c("row") },
                        react_1.default.createElement("span", { className: c("label") },
                            this.quoteViewStore.getLabel(Types_1.QuoteLabel.Total),
                            " ",
                            this.quoteViewStore.getLabel(Types_1.QuoteLabel.Discount)),
                        react_1.default.createElement("span", { className: c("value") }, this.quoteCurrencyFormatter.formatWithUserDecimalPreference(cumulativeDiscountAsNegative)))),
                    this.hasRecurringTotals && (react_1.default.createElement(react_1.default.Fragment, null,
                        !!oneOffTotals.postTax && (react_1.default.createElement("div", { className: c("row") },
                            react_1.default.createElement("span", { className: c("label") },
                                this.quoteViewStore.getLabel(Types_1.QuoteLabel.Total),
                                " ",
                                this.quoteViewStore.getLabel(Types_1.QuoteLabel.OneOff)),
                            react_1.default.createElement("span", { className: c("value") },
                                this.quote.discount.enabled && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("span", { className: "before-discount-total", "aria-label": "Price before discount" }, this.quoteCurrencyFormatter.formatWithUserDecimalPreference(this.preDiscountForBlockTotal(oneOffTotals))),
                                    " ")),
                                this.quoteCurrencyFormatter.formatWithUserDecimalPreference(oneOffTotals.postTax)))),
                        react_1.default.createElement("div", { className: c("list-row") },
                            react_1.default.createElement("span", { className: c("label") },
                                this.quoteViewStore.getLabel(Types_1.QuoteLabel.Total),
                                " ",
                                this.quoteViewStore.getLabel(Types_1.QuoteLabel.Recurring)),
                            react_1.default.createElement("div", { className: c("list-row-values") }, this.sortedRecurringTotals.map(function (total) { return (react_1.default.createElement("span", { className: c("value"), key: total.frequency },
                                _this.quote.discount.enabled && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("span", { className: "before-discount-total", "aria-label": "Price before discount" }, _this.quoteCurrencyFormatter.formatWithUserDecimalPreference(_this.preDiscountForBlockTotal(total))),
                                    " ")),
                                react_1.default.createElement("span", null,
                                    react_1.default.createElement("span", null, _this.quoteCurrencyFormatter.formatWithUserDecimalPreference(total.postTax)),
                                    react_1.default.createElement("span", { className: c("recurring-label") },
                                        " ",
                                        "/",
                                        " ",
                                        _this.quoteViewStore.getLabel((0, Recurrence_1.mapRecurringFrequencyToPerLabel)(total.frequency)))))); }))))),
                    this.quote.showTotalExcludingTaxes && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { className: c("row") },
                            react_1.default.createElement("span", { className: c("label") },
                                this.quoteViewStore.getLabel(Types_1.QuoteLabel.Total),
                                " ",
                                this.quoteViewStore.getLabel(this.hasRecurringTotals ? Types_1.QuoteLabel.DueTodayExcludingTax : Types_1.QuoteLabel.ExcludingTax)),
                            react_1.default.createElement("span", { className: c("value") }, this.quoteCurrencyFormatter.formatWithUserDecimalPreference(finalQuoteTotal.preTax))))),
                    (this.quote.showTotalDiscounts || this.quote.showTotalExcludingTaxes || this.hasRecurringTotals) && (react_1.default.createElement(QuoteTotalSeparator, null)),
                    this.showTaxTotals && (react_1.default.createElement(react_1.default.Fragment, null,
                        (0, lodash_1.map)(finalQuoteTotal.totalTaxes, function (tax, taxLabel) { return (react_1.default.createElement("div", { className: c("row"), key: taxLabel },
                            react_1.default.createElement("span", { className: (0, classnames_1.default)(c("label"), c("label", "tax")) }, taxLabel),
                            react_1.default.createElement("span", { className: (0, classnames_1.default)(c("value"), c("value", "tax")) }, _this.quoteCurrencyFormatter.formatWithUserDecimalPreference(tax)))); }),
                        react_1.default.createElement(QuoteTotalSeparator, null))),
                    react_1.default.createElement("div", { className: c("row") },
                        react_1.default.createElement("span", { className: c("label", "grand") }, this.hasRecurringTotals
                            ? "".concat(this.quoteViewStore.getLabel(Types_1.QuoteLabel.Total), " ").concat(this.quoteViewStore.getLabel(Types_1.QuoteLabel.DueToday))
                            : this.quoteViewStore.getLabel(Types_1.QuoteLabel.Total)),
                        react_1.default.createElement("span", { className: (0, classnames_1.default)(c("value", "grand"), (_a = {},
                                _a[c("value", "inline")] = !!this.quoteComponents.TotalMenu,
                                _a)), "data-synthetics-selector": "quote-total-value", "data-qwilr-component": "quote-total-amount" },
                            this.quoteCurrencyFormatter.formatWithUserDecimalPreference(finalQuoteTotal.postTax),
                            this.quoteComponents.TotalMenu && (react_1.default.createElement("div", { className: c("menu") },
                                react_1.default.createElement(this.quoteComponents.TotalMenu, null)))))))));
    };
    var _a, _b, _c, _d;
    __decorate([
        (0, inversify_react_1.resolve)("quoteCurrencyFormatter"),
        __metadata("design:type", typeof (_a = typeof QuoteCurrencyFormatter_1.default !== "undefined" && QuoteCurrencyFormatter_1.default) === "function" ? _a : Object)
    ], QuoteTotal.prototype, "quoteCurrencyFormatter", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteViewStore_1.QuoteViewStore.$),
        __metadata("design:type", typeof (_b = typeof QuoteViewStore_1.QuoteViewStore !== "undefined" && QuoteViewStore_1.QuoteViewStore) === "function" ? _b : Object)
    ], QuoteTotal.prototype, "quoteViewStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteComponents_1.QuoteComponents.$),
        __metadata("design:type", typeof (_c = typeof QuoteComponents_1.QuoteComponents !== "undefined" && QuoteComponents_1.QuoteComponents) === "function" ? _c : Object)
    ], QuoteTotal.prototype, "quoteComponents", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_d = typeof QuoteBlockStore_1.default !== "undefined" && QuoteBlockStore_1.default) === "function" ? _d : Object)
    ], QuoteTotal.prototype, "quote", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], QuoteTotal.prototype, "hasRecurringTotals", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], QuoteTotal.prototype, "showTaxTotals", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], QuoteTotal.prototype, "sortedRecurringTotals", null);
    QuoteTotal = __decorate([
        mobx_react_1.observer
    ], QuoteTotal);
    return QuoteTotal;
}(react_1.default.Component));
exports.default = QuoteTotal;
